import React, { useEffect, useRef, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Alert, Badge, Button, Row, Col } from 'react-bootstrap';
import { DataManager } from '../../core/data-manager';
import { ApiManager } from '../../core/api-manager';
import { LoginManager } from '../../core/login-manager';
import { LanguageProvider } from '../../core/language-provider';



export default function InstanceCompilerTopHook({ data, entity = null, dataId = null, setDataKeyValue = null }) {

    const location = window.location;
    const [searchParams, setSearchParams] = useSearchParams();
    const [id, setId] = useState(searchParams.get("id") || null);
    const [episodeUser, setEpisodeUser] = useState(null);
    const prefilledAssocRef = useRef(false);


    useEffect(() => {
        if (entity === "event") {
            console.log(location)
            if (location.pathname === "/entity/event/edit") {
                var inputPlace = document.querySelector('#event_field_place')
                if (data.type && data.type.value === "evento") {
                    console.log(1)
                    inputPlace.classList.add('d-none')
                } else {
                    console.log(2)
                    inputPlace.classList.remove('d-none')
                }
            }

        }

    }, []);


    useEffect(() => {
        console.log('DATA', data)
        if (entity === "event") {
            var inputPlace = document.querySelector('#event_field_place')
            if (data.type && data.type.value === "evento") {
                inputPlace.classList.add('d-none')
                console.log(3)
            } else {
                console.log(4)
                inputPlace.classList.remove('d-none')
            }
        }

        if (entity === "user") {
            var inputAssoc = document.querySelector('#user_field_idAssociation')
            if (inputAssoc) {
                var levelVal = data.level && typeof data.level === 'object' ? data.level.value : data.level;
                if (levelVal == 2) {
                    inputAssoc.classList.remove('d-none')
                } else {
                    inputAssoc.classList.add('d-none')
                }
            }
        }


    }, [data]);


    useEffect(() => {
        if ((entity === "event" || entity === "course") && !dataId && setDataKeyValue && !prefilledAssocRef.current) {
            var info = LoginManager.getUserInfo();
            if (!info || info.level != 2) return;

            var timer = setTimeout(async () => {
                if (prefilledAssocRef.current) return;

                var fullUser = info;
                if (info.id) {
                    var resU = await DataManager.getItem('user', info.id);
                    if (resU && resU.success === 1 && resU.body && resU.body[0]) {
                        fullUser = resU.body[0];
                    }
                }

                if (fullUser.idAssociation) {
                    var assoc = null;
                    if (typeof fullUser.idAssociation === 'object' && fullUser.idAssociation.id) {
                        if (fullUser.idAssociation.name) {
                            assoc = fullUser.idAssociation;
                        } else {
                            var resA = await DataManager.getItem('association', fullUser.idAssociation.id);
                            if (resA && resA.success === 1 && resA.body && resA.body[0]) {
                                assoc = resA.body[0];
                            }
                        }
                    } else {
                        var resA = await DataManager.getItem('association', fullUser.idAssociation);
                        if (resA && resA.success === 1 && resA.body && resA.body[0]) {
                            assoc = resA.body[0];
                        }
                    }
                    if (assoc) setDataKeyValue('idAssociation', assoc);
                }

                if (fullUser.idUserGroup) {
                    var group = typeof fullUser.idUserGroup === 'object'
                        ? fullUser.idUserGroup
                        : { id: fullUser.idUserGroup };
                    setDataKeyValue('groups', [group]);
                }

                var assocField = document.querySelector('#' + entity + '_field_idAssociation');
                var groupsField = document.querySelector('#' + entity + '_field_groups');
                [assocField, groupsField].forEach(function (el) {
                    if (el) {
                        el.style.pointerEvents = 'none';
                        el.style.opacity = '0.6';
                        el.setAttribute('title', 'Campo precompilato e non modificabile');
                    }
                });

                prefilledAssocRef.current = true;
            }, 400);

            return () => clearTimeout(timer);
        }
    }, [entity, dataId, setDataKeyValue]);


    useEffect(() => {

        if (entity === "episode_user") {
            if (location.pathname === "/entity/episode_user/edit") {
                console.log('DATA', data)
                getElement();
            }
        }

    }, [data]);


    async function getElement() {
        var response = await DataManager.getItem('gyv_episode_user', id);
        setEpisodeUser(response.body[0])
    }



    if (entity !== null) {
        return (
            <>
                {(() => {
                    switch (entity) {
                        case 'sample':
                            return (
                                <span>Test</span>
                            );
                            break;
                        case 'episode_user':
                            return (
                                <>
                                    <Alert>
                                        <Row>
                                            <Col><b>Nome:</b> {episodeUser && episodeUser.name}</Col>
                                        </Row>
                                        <Row>
                                            <Col><b>Cognome:</b> {episodeUser && episodeUser.surname}</Col>
                                        </Row>
                                        <Row>
                                            <Col><b>Email:</b> {episodeUser && episodeUser.email}</Col>
                                        </Row>
                                        <Row>
                                            <Col><b>Corso:</b> {episodeUser && episodeUser.course}</Col>
                                        </Row>
                                        <Row>
                                            <Col><b>Episodio:</b> {episodeUser && episodeUser.episode}</Col>
                                        </Row>
                                    </Alert>
                                </>

                            );
                            break;
                        default:
                            return (
                                <></>
                            );
                            break;
                    }
                })()}
            </>
        )
    }
    else {
        return (
            <></>
        )
    }
};